import { render, staticRenderFns } from "./CostSummary.vue?vue&type=template&id=c89dbc84&"
import script from "./CostSummary.vue?vue&type=script&lang=js&"
export * from "./CostSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports